import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import EditHeader from '../components/EditHeader';
import EditItemsContainer from '../components/EditItemsContainer';
import Header from '../components/Header';
import useAuth from '../hooks/useAuth';
import homeIcon from '../images/home.svg'
import backIcon from '../images/back.svg'

const EditPreviousUploadedItem = () => {

    const { id } = useParams()
    const navigate = useNavigate()
    const { setEditProducts, editProducts } = useAuth()
    const [data, setData] = useState({})
    const [products, setProducts] = useState([])

    useEffect(() => {
        fetch(`https://vendor-managed-inventory-transparency.onrender.com/vendor-inventory-stock/${id}`)
            .then(response => response.json())
            .then(data => {
                setData(data)
                setEditProducts(data.products)
                setProducts(data.products)
            })
    }, [id, setEditProducts])

    const handleClick = () => {

        document.getElementById('edit-action').style.display = 'none'
        document.getElementById('edit-processing').style.display = 'block'

        const productDetails = {
            products: editProducts
        }

        fetch(`https://vendor-managed-inventory-transparency.onrender.com/vendor-inventory-stock/${data._id}`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(productDetails)
        })
            .then(res => res.json())
            .then(data => {
                data.status === true ?
                    Swal.fire({
                        icon: 'success',
                        text: `${data.message}`,
                    }) :
                    Swal.fire({
                        icon: 'error',
                        text: `${data.message}`,
                    })
                document.getElementById('edit-action').style.display = 'block'
                document.getElementById('edit-processing').style.display = 'none'

            }).catch(err => Swal.fire({
                icon: 'error',
                text: `${err}!`,
            }))
        document.getElementById('edit-action').style.display = 'block'
        document.getElementById('edit-processing').style.display = 'none'
    }

    return (
        <div className='bg-brand'>
            <div className="container">

                <div className="d-flex justify-content-between align-items-center pt-3">
                    <h2 className='fs-5'><Link to='' onClick={()=> navigate(-1)} className='text-decoration-none'><img width={18} className='img-fluid mb-1 me-2' src={backIcon} alt="go home" />Go Back</Link></h2>
                    <h2 className='fs-5'><Link to='/' className='text-decoration-none'>Go Home<img className='img-fluid mb-2 ms-2' src={homeIcon} alt="go home" /></Link></h2>
                </div>

                <Header />

                <EditHeader data={data} />

                {
                    products.length > 0 ? <EditItemsContainer data={editProducts} /> : <p>Loading...</p>
                }

                <div className="d-flex justify-content-center align-items-center mt-3">
                    <button onClick={() => handleClick()} id="edit-action" className='btn-action w-75'>Save & Submit</button>
                    <button style={{ display: 'none' }} id='edit-processing' className='btn-action w-75' disabled><div style={{ height: '15px', width: '15px' }} className="spinner-border me-1"></div>Processing . . .</button>
                </div>
            </div>
        </div>
    );
};

export default EditPreviousUploadedItem;